import { render, staticRenderFns } from "./ViewerSidebarDesign.vue?vue&type=template&id=2bf59ce3&scoped=true"
import script from "./ViewerSidebarDesign.vue?vue&type=script&lang=js"
export * from "./ViewerSidebarDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerSidebarDesign.vue?vue&type=style&index=0&id=2bf59ce3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf59ce3",
  null
  
)

export default component.exports